import React, { useEffect, useState } from "react";
import { TableRow, useTheme, Typography } from "@mui/material";
import { styled } from "@mui/system";
import {
  Tablecell,
  calculateAndFormat,
  formatValue,
  calculateAndFormatNoAbs,
} from "../../component/Methods";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import TradesPopUp from "./Popup/TradesPopUp";
import ClosePositionLong from "./Popup/ClosePosition/ClosePosition/ClosePositionLong";
import { useSelector } from "react-redux";
import {
  selectStrategies,
  selectFunds,
} from "../../Redux/Reducers/selectors";

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#5A5A5A",
    color: "#fff",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}));

const LongTable = React.memo((props) => {
  const { row, fundVal, strategyVal, visible } = props;
  const funds = useSelector(selectFunds);
  const strategies = useSelector(selectStrategies);
  const [myFund, setMyFund] = useState({});
  const [myStrategy, setMyStrategy] = useState({});
  const [formattedSize, setFormattedSize] = useState("");
  const [isLong, setIsLong] = useState(false);
  const [closePos, setClosePos] = useState(false);
  const [
    formattedDeltaAdjustedShareCount,
    setFormattedDeltaAdjustedShareCount,
  ] = useState("");
  const [formattedLast, setFormattedLast] = useState("");
  const [ticker, setTicker] = useState("");
  const [formattedCurrent, setFormattedCurrent] = useState("");
  const [formattedCh, setFormattedCh] = useState("");
  const [formattedPL, setFormattedPL] = useState("");
  const [formattedChPercentage, setFormattedChPercentage] = useState("");
  const [formattedCost, setFormattedCost] = useState(0);
  const [formattedAvgCost, setformattedAvgCost] = useState(0);
  const [formattedPerAvgCost, setformattedPerAvgCost] = useState(0);
  const [tdg, setTdg] = useState(0);

  useEffect(() => {
    setFormattedSize(formatValue(row?.long_size));
    setFormattedDeltaAdjustedShareCount(
      calculateAndFormat(row?.long_deltaadjustedsharecount)
    );
    setTicker(row?.long_tickerSymbol);
    setFormattedLast(formatValue(row?.long_last));
    setFormattedCurrent(formatValue(row.long_current));
    setFormattedCh(row?.long_ch);
    setFormattedPL(row?.long_pL);
    setFormattedCost(row?.long_cost);
    setFormattedChPercentage(row?.long_chpercentage);
    setformattedAvgCost(row?.long_pl_avg_cost);
    setformattedPerAvgCost(row?.long_percentage_avg_cost);
    setTdg(row?.long_tdg);
  }, [row]);

  const handleLong = (obj) => {
    // setIsLong(true);
    if (
      fundVal &&
      strategyVal &&
      fundVal.toUpperCase() !== "ALL" &&
      strategyVal.toUpperCase() !== "ALL"
    ) {
      const fund = funds?.find((i) => i.abbreviation == fundVal);
      const strategy = strategies?.find((i) => i.name == strategyVal);
      setMyFund(fund);
      setMyStrategy(strategy);
      setClosePos(true);
    } else {
      setMyFund({});
      setMyStrategy({});
      setClosePos(false);
    }
  };
  const theme = useTheme();
  return (
    <React.Fragment>
      <TableRow
        sx={{
          backgroundColor: theme.palette.grey[100],
          "&:hover": {
            background: theme.palette.grey[200],
            cursor: "pointer",
          },
        }}
        onClick={() => {
          handleLong(row);
        }}
      >
        <Tablecell
          style={{ width: "50px" }}
          align="right"
          sx={{
            paddingRight: "5px",
            color: theme.palette.text.primary,
            border: `1px solid ${
              theme.palette.mode === "dark"
                ? theme.palette.grey[300]
                : theme.palette.grey[300]
            }`,
          }}
        >
          {formattedSize ? `${formattedSize}%` : "0.00%"}
        </Tablecell>
        <Tablecell
          align="right"
          sx={{
            paddingRight: "5px",
            color: theme.palette.text.primary,
            border: `1px solid ${
              theme.palette.mode === "dark"
                ? theme.palette.grey[300]
                : theme.palette.grey[300]
            }`,
          }}
        >
          {formattedDeltaAdjustedShareCount || ""}
        </Tablecell>

        <Tablecell
          style={{
            width: "20px",
            paddingLeft: "5px",
            cursor: "pointer",
            color: theme.palette.text.primary,
            border: `1px solid ${
              theme.palette.mode === "dark"
                ? theme.palette.grey[300]
                : theme.palette.grey[300]
            }`,
          }}
          align="left"
        >
          {ticker ? ticker.toUpperCase() : ""}
        </Tablecell>
        <HtmlTooltip
          title={
            <React.Fragment>
              <Typography color="inherit" sx={{ fontSize: "12px" }}>
                Market:<b> {row?.dataSource} </b>
              </Typography>

              <Typography color="inherit" sx={{ fontSize: "12px" }}>
                Updated: <b>{row?.fetched}</b>
              </Typography>
            </React.Fragment>
          }
        >
          <Tablecell
            style={{
              width: "20px",
              paddingRight: "5px",
              backgroundColor: row?.valid ? "#baffc8" : "#ffdcdc",
              border: `1px solid ${
                theme.palette.mode === "dark"
                  ? theme.palette.grey[300]
                  : theme.palette.grey[300]
              }`,
            }}
            align="right"
          >
            {formattedLast || ""}
          </Tablecell>
        </HtmlTooltip>
        <HtmlTooltip
          title={
            <React.Fragment>
              <Typography color="inherit" sx={{ fontSize: "12px" }}>
                Market:<b> {row?.dataSource} </b>
              </Typography>

              <Typography color="inherit" sx={{ fontSize: "12px" }}>
                Updated: <b>{row?.fetched}</b>
              </Typography>
            </React.Fragment>
          }
        >
          <Tablecell
            style={{
              width: "20px",
              paddingRight: "5px",
              backgroundColor: row?.valid ? "#baffc8" : "#ffdcdc",
              border: `1px solid ${
                theme.palette.mode === "dark"
                  ? theme.palette.grey[300]
                  : theme.palette.grey[300]
              }`,
            }}
            align="right"
          >
            {formattedCurrent || ""}
          </Tablecell>
        </HtmlTooltip>
        {formattedCh ? (
          <Tablecell
            align="right"
            style={{
              color:
                formattedCh >= 0
                  ? theme.palette.mode === "dark"
                    ? "#4ade80"
                    : "#16a34a"
                  : theme.palette.mode === "dark"
                  ? "#f87171"
                  : "#dc2626",
              paddingRight: "2px",
              border: `1px solid ${
                theme.palette.mode === "dark"
                  ? theme.palette.grey[300]
                  : theme.palette.grey[300]
              }`,
            }}
          >
            {formattedCh >= 0
              ? parseFloat(formattedCh).toFixed(2)
              : `(${(formattedCh * -1).toFixed(2)})`}
            &nbsp;
          </Tablecell>
        ) : (
          <Tablecell align="right"></Tablecell>
        )}

        {formattedPL ? (
          <Tablecell
            align="right"
            style={{
              color:
                formattedPL >= 0
                  ? theme.palette.mode === "dark"
                    ? "#4ade80"
                    : "#16a34a"
                  : theme.palette.mode === "dark"
                  ? "#f87171"
                  : "#dc2626",
              paddingRight: "2px",
              border: `1px solid ${
                theme.palette.mode === "dark"
                  ? theme.palette.grey[300]
                  : theme.palette.grey[300]
              }`,
            }}
          >
            {formattedPL >= 0
              ? Math.round(formattedPL).toLocaleString()
              : `(${(Math.round(formattedPL) * -1).toLocaleString()})`}
            &nbsp;
          </Tablecell>
        ) : (
          <Tablecell
            align="right"
            style={{
              border: `1px solid ${
                theme.palette.mode === "dark"
                  ? theme.palette.grey[300]
                  : theme.palette.grey[300]
              }`,
            }}
          ></Tablecell>
        )}
        {formattedChPercentage ? (
          <Tablecell
            style={{
              color:
                formattedChPercentage >= 0
                  ? theme.palette.mode === "dark"
                    ? "#4ade80"
                    : "#16a34a"
                  : theme.palette.mode === "dark"
                  ? "#f87171"
                  : "#dc2626",
              width: "20px",
              paddingRight: "2px",
              border: `1px solid ${
                theme.palette.mode === "dark"
                  ? theme.palette.grey[300]
                  : theme.palette.grey[300]
              }`,
            }}
            align="right"
          >
            {formattedChPercentage >= 0
              ? `${formattedChPercentage?.toFixed(3)}%`
              : `(${Math.abs(formattedChPercentage).toFixed(3)}%)`}
          </Tablecell>
        ) : (
          <Tablecell
            align="right"
            style={{
              border: `1px solid ${
                theme.palette.mode === "dark"
                  ? theme.palette.grey[300]
                  : theme.palette.grey[300]
              }`,
            }}
          ></Tablecell>
        )}
        {visible ? (
          <>
            {" "}
            <Tablecell
              align="right"
              style={{
                paddingRight: "5px",
                color: theme.palette.text.primary,
                border: `1px solid ${
                  theme.palette.mode === "dark"
                    ? theme.palette.grey[300]
                    : theme.palette.grey[300]
                }`,
              }}
            >
              {formattedAvgCost >= 0
                ? calculateAndFormatNoAbs(formattedAvgCost)
                : `(${calculateAndFormatNoAbs(Math.abs(formattedAvgCost))})`}
            </Tablecell>
            <Tablecell
              align="right"
              style={{
                paddingRight: "5px",
                color: theme.palette.text.primary,
                border: `1px solid ${
                  theme.palette.mode === "dark"
                    ? theme.palette.grey[300]
                    : theme.palette.grey[300]
                }`,
              }}
            >
              {formattedPerAvgCost >= 0
                ? `${formattedPerAvgCost?.toFixed(2)}%`
                : `(${Math.abs(formattedPerAvgCost).toFixed(2)}%)`}
            </Tablecell>
          </>
        ) : null}

        <Tablecell
          align="right"
          style={{
            paddingRight: "5px",
            color: theme.palette.text.primary,
            border: `1px solid ${
              theme.palette.mode === "dark"
                ? theme.palette.grey[300]
                : theme.palette.grey[300]
            }`,
          }}
        >
          {formattedCost?.toFixed(2)}
        </Tablecell>
        <Tablecell
          align="right"
          style={{
            color:
              tdg >= 0
                ? theme.palette.mode === "dark"
                  ? "#4ade80"
                  : "#16a34a"
                : theme.palette.mode === "dark"
                ? "#f87171"
                : "#dc2626",
            border: `1px solid ${
              theme.palette.mode === "dark"
                ? theme.palette.grey[300]
                : theme.palette.grey[300]
            }`,
            width: "20px",
            paddingRight: "5px",
          }}
        >
          {tdg == 0
            ? ""
            : tdg >= 0
            ? Math.round(tdg).toLocaleString() + " "
            : `(${(Math.round(tdg) * -1).toLocaleString()})`}
        </Tablecell>
      </TableRow>
      {/* <TradesPopUp
        open={isLong}
        setOpen={setIsLong}
        ticker={ticker}
        shareCount={formattedDeltaAdjustedShareCount}
        marketPrice={formattedCurrent}
        yeserdaytPrice={formattedLast}
        title="Position"
      /> */}
      <ClosePositionLong
        closePos={closePos}
        setClosePos={setClosePos}
        title="CLOSE POSITION"
        row={row}
        myFund={myFund}
        myStrategy={myStrategy}
      />
    </React.Fragment>
  );
});

// Memoize the component to prevent unnecessary re-renders
export default React.memo(LongTable);
